module.exports = __webpack_public_path__ + "static/media/VU4110F0.0d29552f.png";